import { loadSofaElement } from '../DynamicLoadSofaShape'

export interface ChangeableProperties {
  width?: boolean
  height?: boolean
  length?: boolean
  seat_height?: boolean
  seat_depth?: boolean
  seat_width?: boolean
  corner_radius?: boolean
  armrest_width?: boolean
  backrest_width?: boolean
  number_of_big_pillows?: boolean
  number_of_small_pillows?: boolean
  spread_of_small_pillows?: boolean
  spread_of_big_pillows?: boolean
  size_of_big_pillow?: boolean
  size_of_pillow?: boolean
  extension_type?: boolean
  backrest_type?: boolean
  angle?: boolean
  covered_side?: boolean
}

// Default changeable properties (fallback when shape doesn't have getDefaultSettings)
const DEFAULT_CHANGEABLE_PROPERTIES: ChangeableProperties = {
  width: true,
  height: true,
  length: true,
  // seat_height: true,
  // seat_depth: true,
  // seat_width: true,
  // corner_radius: true,
  armrest_width: true,
  backrest_width: true,
  // number_of_big_pillows: true,
  // number_of_small_pillows: true,
  // spread_of_small_pillows: true,
  // spread_of_big_pillows: true,
  // size_of_big_pillow: true,
  // size_of_pillow: true,
  extension_type: true,
  backrest_type: true,
}

/**
 * Get changeable properties for a sofa shape type
 * If the shape has getDefaultSettings function, use its changeableProperties
 * Otherwise, return default properties (all fields changeable)
 */
export const getShapeChangeableProperties = async (
  shapeType: string
): Promise<ChangeableProperties> => {
  try {
    const moduleExports = await loadSofaElement(shapeType)

    if (moduleExports?.getDefaultSettings) {
      const settings = moduleExports.getDefaultSettings()
      return settings.changeableProperties || DEFAULT_CHANGEABLE_PROPERTIES
    }

    // Fallback to default properties if shape doesn't have getDefaultSettings
    return DEFAULT_CHANGEABLE_PROPERTIES
  } catch (error) {
    console.error('Error loading shape configuration:', error)
    // Return default properties on error
    return DEFAULT_CHANGEABLE_PROPERTIES
  }
}
